import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="w-full bg-foreground-900 text-foreground-200">
      <div className="w-full px-4 md:px-8 lg:px-12 xl:px-16 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-start gap-10">
            <div className="max-w-sm">
              <h3 className="font-heading text-xl font-semibold text-white">
                Haus Dornumersiel
              </h3>
              <p className="mt-3 text-sm text-foreground-400 leading-relaxed">
                {t('hero.subtitle')}
              </p>
              <div className="mt-5 flex items-center gap-3">
                <a
                  href="mailto:info@haus-dornumersiel.de"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-foreground-700 text-foreground-300 transition-colors cursor-pointer"
                  aria-label="Email"
                >
                  <i className="ri-mail-line text-sm" />
                </a>
                <a
                  href="tel:+49493312345"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-foreground-700 text-foreground-300 transition-colors cursor-pointer"
                  aria-label="Phone"
                >
                  <i className="ri-phone-line text-sm" />
                </a>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-8 sm:gap-16">
              <div>
                <h4 className="text-sm font-semibold text-white uppercase tracking-wider">
                  Navigation
                </h4>
                <ul className="mt-4 space-y-2.5">
                  <li>
                    <button onClick={() => scrollToTop()} className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">
                      {t('nav.home')}
                    </button>
                  </li>
                  <li>
                    <a href="#about" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">
                      {t('nav.about')}
                    </a>
                  </li>
                  <li>
                    <a href="#gallery" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">
                      {t('nav.gallery')}
                    </a>
                  </li>
                  <li>
                    <a href="#booking" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">
                      {t('nav.booking')}
                    </a>
                  </li>
                  <li>
                    <a href="#contact" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">
                      {t('nav.contact')}
                    </a>
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="text-sm font-semibold text-white uppercase tracking-wider">
                  Rechtliches
                </h4>
                <ul className="mt-4 space-y-2.5">
                  <li>
                    <Link to="/impressum" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">
                      {t('footer.impressum')}
                    </Link>
                  </li>
                  <li>
                    <Link to="/datenschutz" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">
                      {t('footer.datenschutz')}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} Haus Dornumersiel. {t('footer.rights')}
            </p>
            <p className="text-xs text-foreground-500">{t('footer.madeWith')}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}